import CustomTabs from "@components/CustomTabs"
import { techStacks } from "./TabsTechStacks"

export const TechnologiesWeUseFor = ()=>{
   return(
    <section className="container">
            <CustomTabs techStacks={techStacks}   title = "Technologies We Use for IoT Software Development"/>
    
    </section>
   )
}